import React from "react";
import { FileText, ExternalLink, ArrowRight } from "lucide-react";
import { PageHero, PageBody } from "./_shared";

/**
 * Shared PDF list page used by Important Links, Notices, Admissions.
 * Ink + gold Southwestern-inspired look. `accent` prop is retained for
 * signature compatibility but ignored — the theme is now uniform.
 */
export default function PdfListPage({ eyebrow, title, items, emptyMsg, testid }) {
  const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  const isNew = (it) => {
    const ts = it.created_at ? new Date(it.created_at).getTime() : NaN;
    return Number.isFinite(ts) && ts >= sevenDaysAgo;
  };
  return (
    <div data-testid={testid}>
      <PageHero eyebrow={eyebrow} title={title} />
      <PageBody>
        {items.length === 0 ? (
          <div className="text-center bg-white p-16 border border-[#D9D2C1] text-[#726C61]">
            {emptyMsg || "Nothing posted yet."}
          </div>
        ) : (
          <ul className="grid md:grid-cols-2 gap-3">
            {items.map((it) => (
              <li
                key={it.id}
                data-testid={`${testid}-item-${it.id}`}
                className="bg-white border-l-4 border-[#FDBB30] border-t border-r border-b border-[#D9D2C1] hover:shadow-md transition-shadow flex items-center gap-4 p-5"
              >
                <div className="w-11 h-11 bg-[#0F0F10] text-[#FDBB30] flex items-center justify-center shrink-0">
                  <FileText size={18} strokeWidth={1.6} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[15px] font-medium text-[#0F0F10] flex items-center gap-2">
                    <span className="truncate">{it.name}</span>
                    {isNew(it) && (
                      <span
                        data-testid={`${testid}-new-badge-${it.id}`}
                        className="shrink-0 inline-flex items-center text-[9px] font-bold tracking-[0.2em] uppercase px-2 py-0.5 bg-[#FDBB30] text-[#0F0F10]"
                      >
                        New
                      </span>
                    )}
                  </div>
                </div>
                {(it.pdf_url || it.external_url) ? (
                  <a
                    href={it.pdf_url || it.external_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.22em] font-bold text-[#0F0F10] hover:text-[#E19E14] border-b-2 border-[#FDBB30] pb-0.5"
                  >
                    Open <ArrowRight size={12} strokeWidth={2.4} />
                    <span className="sr-only"><ExternalLink size={11} /></span>
                  </a>
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </PageBody>
    </div>
  );
}
